// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1sKpl","bigColWidth":"Table_bigColWidth__XanwI","biggerColWidth":"Table_biggerColWidth__2B2Ss","row":"Table_row__2bxXA","col":"Table_col__1CvLJ"};